import { Pipe, PipeTransform } from '@angular/core';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';
import { SlaStatusByExpireDatePipe } from './sla-status-by-expired-date';
import { SLATypeDetails } from '../../app-create-case/models/insurance-case.model';
import { CaseReportInfo } from '../models/domain/CaseReportInfo';

@Pipe({
    name: 'slaTypeImageSource',
    standalone: false
})
export class SlaTypeImageSourcePipe implements PipeTransform {
    transform(slaDetails: SLATypeDetails, caseReportList: CaseReportInfo[], readyForBillingDate: any): string {
        const slaStatusByExpiryDate = new SlaStatusByExpireDatePipe();
        const currentSlaStatus = slaStatusByExpiryDate.transform(slaDetails, caseReportList, readyForBillingDate);
        // SLATypes['FAST', 'NORMAL']
        return slaDetails?.SLAType === SCConfig.SLATypes[1]
            ? SCConfig.SlaStatusNormal.get(currentSlaStatus)
            : SCConfig.SlaStatusFast.get(currentSlaStatus);
    }
}
